import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action} from '@ngrx/store';
import {ROUTER_NAVIGATION, RouterNavigationAction} from '@ngrx/router-store';
import {map} from 'rxjs/internal/operators';
import {SetShowHeaderAction} from '../store/showHeader/reducer';

@Injectable()
export class ShowHeaderEffects {
  @Effect()
  routing$: Observable<Action> = this.actions$.pipe(
    ofType(ROUTER_NAVIGATION),
    map((action: RouterNavigationAction) => {
      return new SetShowHeaderAction(!action.payload.routerState.url.startsWith('/superuser'));
    }),
  );

  constructor(private actions$: Actions) {}
}
